<script lang="ts">
    import { fade } from 'svelte/transition';
    import '@root/src/utils/animations.js';
    import { onMount } from 'svelte';
    import { getCountDecimals } from '@root/src/utils/global';
    import { gsap, Power3 } from 'gsap';

    export let amount: string;
    export let currency: string;
    export let duration = 3.5;

    let amountMoneyEl: HTMLDivElement | null = null;
    onMount(() => {
        const timeline = gsap.timeline();
        timeline.counter(amountMoneyEl, {
            duration: Math.min(duration, 6),
            end: amount,
            currency,
            ease: Power3.easeOut,
            countDecimals: getCountDecimals(amount),
            counterSound: window.__assets_cache.audio_amount_count_up
        });

        return () => {
            timeline.kill();
        };
    });
</script>

<div
    class="root absolute left-1/2 top-3/4 z-8000 flex -translate-x-1/2 flex-col items-center font-Sofia narrow-tablet:translate-y-0"
    transition:fade|global
>
    <div
        class="win-text-gradient text-stroke win-text-shadow relative truncate text-8xl font-bold leading-tight"
        bind:this={amountMoneyEl}
        class:!win-amount-dynamic-font-size={amount.toString().length > 6}
    >
        {amount}
    </div>
    <div class="win-text-gradient text-stroke win-text-shadow relative mt-2 text-xl leading-none tablet:text-2xl">
        {currency}
    </div>
</div>

<style>
    .text-stroke {
        -webkit-text-stroke: 1px #b6b6b6;
    }
</style>
